import { Typography } from 'antd';
import { FC } from 'react';

import { BRAND_COLORS } from '../../../../../../constants/styles';

const { Text } = Typography;

export const FormulaLine: FC<{
  marginTop?: number;
  children: React.ReactNode;
}> = ({ marginTop, children }) => (
  <Text
    style={{
      color: BRAND_COLORS.secondary.lightSage,
      fontSize: 12,
      fontFamily: 'monospace',
      display: 'block',
      marginTop,
    }}
  >
    {children}
  </Text>
);
